import UserLayout from './UserLayout'

import { renderRoutes } from 'react-router-config'

function Blank(props) {
  const { route } = props
  return renderRoutes(route.routes)
}

export { UserLayout, Blank }

export default UserLayout
